export const PROJECT_TITLE = {
  // ProjectTitle elements
  WARNING_TOOLTIP_CLOSE_BUTTON: 'project-title-warning-tooltip-close-button',

  // ProjectVersionPopup elements
  VERSION_POPUP_CLOSE_BUTTON: 'project-title-version-popup-close-button',
  SET_DATA_DATE_BUTTON: 'project-title-set-data-date-button',
  EDIT_DATA_DATE_BUTTON: 'project-title-edit-data-date-button',
  VIEW_ALL_VERSIONS_BUTTON: 'project-title-view-all-versions-button',

  // ProjectInfoPanel elements
  INFO_CLOSE_BUTTON_DIALOG: 'project-title-info-close-button-dialog',
  INFO_PANEL_CLOSE_BUTTON: 'project-title-info-panel-close-button',
  INFO_PANEL_COLLAPSE_BUTTON: 'project-title-info-panel-collapse-button',
  INFO_PANEL_LINK_BUTTON: 'project-title-info-panel-link-button',
  INFO_PANEL_SET_DATA_DATE_BUTTON: 'project-title-info-panel-set-data-date-button',
  INFO_PANEL_EDIT_DATA_DATE_BUTTON: 'project-title-info-panel-edit-data-date-button',
  INFO_PANEL_COMMITTED_PILL: 'project-title-info-panel-committed-pill',

  // ProjectsListPanel elements
  PROJECTS_LIST_COLLAPSE_BUTTON: 'project-title-projects-list-collapse-button',
  PROJECT_LIST_ITEM_LINK: 'project-title-project-list-item-link'
} as const;
